module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/sorority-e1fdf785c6918258643ab6ff45da1553.jpg";